module.exports = __webpack_public_path__ + "static/media/creditasHG.bf7cf016.svg";